import { useState, useRef, useContext, createRef, useEffect, Fragment } from 'react';

import styles from "./NotesComponent.module.css"

import { GlobalContext } from '../../../contexts/globalContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons'

import CustomMultitouchComponent from '../../../files/CustomMultitouchComponent';
import MobileQRComponent from '../filesComponents/MobileQRComponent'
import NoteAreaComponent from '../../keyboard/NoteAreaComponent'
import New_InputTextComponent from '../../keyboard/New_InputTextComponent';

import sendEmailImg from '../../../graphics/featuresGraphics/Send-Note-Img.png'
import backgroundImg from '../../../graphics/featuresGraphics/img-note.png'
import resizeButton from '../../../graphics/conferenceScreen/note/expand.svg'

const NotesComponent = ({ setSeeNoteFeature }) => {

    const { appWidth, appHeight, keyboardRef, socketRef, currentConference, currentParticipant, setAlertMessage } = useContext(GlobalContext)

    const ref = useRef()
    const compRef = useRef()
    const noteRef = useRef()
    const startX = useRef(0);
    const startY = useRef(0);
    const isDragging = useRef(false);
    const draggedElement = useRef(null);
    const selectedNoteRef = useRef(null)
    const inputEmailRef = useRef(null)
    const isOpenCanvasRef = useRef(false);

    const [notesTexts, setNotesTexts] = useState([]);
    const [selectedNote, setSelectedNote] = useState()
    const [showQR, setShowQR] = useState()
    const [draggedNoteId, setDraggedNoteId] = useState(null);
    const [showSendToEmail, setShowSendToEmail] = useState();
    const [disabled, setDisabled] = useState(false);

    const notesRefs = useRef({});

    const options = {
        appWidth: appWidth,
        appHeight: appHeight,
        minScale: 0.5,
        maxScale: 1.25

    }

    useEffect(() => {

        socketRef.current.emit("CONFERENCE_GET_NOTES", currentConference._id, currentParticipant?._id, (callback) => {
            if (!callback.error) {
                let notes = sortNotesByUpdatedAt(callback.response)
                notes.forEach(note => {
                    if (!notesRefs.current[note._id]) {
                        notesRefs.current[note._id] = createRef();
                    }
                });
                setNotesTexts(notes)
            } else {
                setAlertMessage({ type: "ERROR", message: callback.message })
            }
        });

        window.addEventListener('pointerup', windowPointerUp);
        window.addEventListener('pointermove', resizePointerMove)

        socketRef.current.on('REFRESH_CONFERENCE_NOTES', function (conferenceId) {
            if (currentConference && currentConference._id === conferenceId) {

                socketRef.current.emit("CONFERENCE_GET_NOTES", currentConference._id, currentParticipant?._id, (callback) => {
                    if (!callback.error) {
                        callback.response.forEach(note => {
                            if (!notesRefs.current[note._id]) {
                                notesRefs.current[note._id] = createRef();
                            }
                        });
                        setNotesTexts(callback.response)
                    } else {
                        setAlertMessage({ type: "ERROR", message: callback.message })
                    }
                });
            }
        });

        return () => {
            window.removeEventListener('pointerup', windowPointerUp)
            window.removeEventListener('pointermove', resizePointerMove)
        }
    }, [])

    const addNewNote = () => {
        socketRef.current.emit("CONFERENCE_UPDATE_NOTE", null, currentConference._id, currentParticipant?._id, "", (callback) => {
            if (!callback.error) {
                let notes = sortNotesByUpdatedAt(callback.response)
                notes.forEach(note => {
                    if (!notesRefs.current[note._id]) {
                        notesRefs.current[note._id] = createRef();
                    }
                });
                setNotesTexts(notes)
                setSelectedNote(notes[0])
                setShowQR(false)
                setShowSendToEmail(false)
            } else {
                setAlertMessage({ type: "ERROR", message: callback.message })
            }
        });
    }


    const deleteNote = (id) => {
        socketRef.current.emit("CONFERENCE_DELETE_NOTE", id, (callback) => {
            if (!callback.error) {
                let notes = sortNotesByUpdatedAt(callback.response)
                setNotesTexts(notes)

                if (id === selectedNote?._id) {
                    setSelectedNote()
                }
            } else {
                setAlertMessage({ type: "ERROR", message: callback.message })
            }
        });
    }

    const changeNote = () => {
        let value = noteRef.current?.value
        let id = selectedNoteRef.current._id
        socketRef.current.emit("CONFERENCE_UPDATE_NOTE", id, currentConference._id, currentParticipant?._id, value, (callback) => {
            if (!callback.error) {
                let notes = sortNotesByUpdatedAt(callback.response)
                setNotesTexts(notes)
                setSelectedNote({ ...selectedNoteRef.current, text: value })
            } else {
                setAlertMessage({ type: "ERROR", message: callback.message })
            }
        });

    }


    const sendNotes = () => {
        if (disabled) return;

        if (inputEmailRef.current.value !== "") {
            setDisabled(true)
            socketRef.current.emit("CONFERENCE_SEND_NOTES", currentConference._id, currentParticipant?._id, (callback) => {
                if (!callback.error) {
                    setAlertMessage({ type: "SUCCESS", message: callback.response + ". Succes!" })
                } else {
                    setAlertMessage({ type: "ERROR", message: callback.message })
                }
                setDisabled(false)
            });
        } else {
            setAlertMessage({ type: "WARNING", message: "Please fill in you email." })
        }

    }

    const pointerLastX = useRef();
    const pointerLastY = useRef();
    const isResizingRef = useRef(false);
    const initialWidthRef = useRef(1778);
    const initialHeightRef = useRef(980);
    const widthRef = useRef(initialWidthRef.current);
    const heightRef = useRef(initialHeightRef.current);

    const [width, setWidth] = useState(initialWidthRef.current);
    const [height, setHeight] = useState(initialHeightRef.current);

    // drag baseline (size at pointerDown)
    const dragBaseWRef = useRef(width);
    const dragBaseHRef = useRef(height);
    // virtual un-clamped deltas since pointerDown
    const dragDXRef = useRef(0);
    const dragDYRef = useRef(0);

    const currentScaleRef = useRef(1);

    const MAX_W = initialWidthRef.current * 1.8;
    const MAX_H = initialHeightRef.current * 1.8;
    const MIN_W = initialWidthRef.current;
    const MIN_H = initialHeightRef.current;

    const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

    const resizePointerDown = (e) => {
        isResizingRef.current = true;
        pointerLastX.current = e.screenX;
        pointerLastY.current = e.screenY;

        // lock the baseline to the displayed size at drag start
        dragBaseWRef.current = width;
        dragBaseHRef.current = height;

        // reset virtual deltas
        dragDXRef.current = 0;
        dragDYRef.current = 0;
    };

    const oxDivider = window.innerWidth / appWidth;
    const oyDivider = window.innerHeight / appHeight;

    const resizePointerMove = (e) => {
        if (!isResizingRef.current) return;

        const dx = (e.screenX - pointerLastX.current) / oxDivider / currentScaleRef.current;
        const dy = (e.screenY - pointerLastY.current) / oyDivider / currentScaleRef.current;

        // accumulate *virtual* deltas since drag start
        dragDXRef.current += dx;
        dragDYRef.current += dy;

        // compute proposed (unclamped) sizes from the drag baseline
        const proposedW = dragBaseWRef.current + dragDXRef.current;
        const proposedH = dragBaseHRef.current + dragDYRef.current;

        // clamp only for display
        const nextW = clamp(proposedW, MIN_W, MAX_W);
        const nextH = clamp(proposedH, MIN_H, MAX_H);

        widthRef.current = nextW;
        heightRef.current = nextH;
        setWidth(nextW);
        setHeight(nextH);

        pointerLastX.current = e.screenX;
        pointerLastY.current = e.screenY;
    };

    const windowPointerUp = () => {
        isResizingRef.current = false;
    };


    const onPinch = (currentScale) => {
        currentScaleRef.current = currentScale;
    }

    const showQRVerify = () => {
        if (currentConference.type === "Presentation") {
            return (currentParticipant?.presentation === currentConference._id || currentConference.moderatedBy === currentParticipant?._id)
        } else if (currentConference.type === "Conference") {
            for (let i = 0; i < currentConference.topics.length; i++) {
                let topic = currentConference.topics[i]
                if (topic.moderator._id === currentParticipant?._id) {
                    return true
                }
            }
        }
        return false
    }

    function getFirstLine(text) {
        if (typeof text !== 'string') return '';
        const [firstLine] = text.split('\n');
        return firstLine;
    }

    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    function sortNotesByUpdatedAt(notesTexts) {
        const now = new Date();
        return [...notesTexts].map(note => {
            const updatedAt = note.updatedAt ? new Date(note.updatedAt) : new Date("2025-06-11T00:00:00.043Z");
            let timeCategory = null;

            if (updatedAt) {
                const diffTime = now - updatedAt;
                const diffDays = diffTime / (1000 * 60 * 60 * 24);

                if (updatedAt.toDateString() === now.toDateString()) {
                    timeCategory = "Today";
                } else if (diffDays <= 7) {
                    timeCategory = "Previous 7 days";
                } else if (diffDays <= 30) {
                    timeCategory = "Previous 30 days";
                } else if (updatedAt.getFullYear() === now.getFullYear()) {
                    timeCategory = "Earlier this year";
                } else {
                    timeCategory = "A long time ago";
                }
            }

            return {
                ...note,
                timeCategory,
            };
        }).sort((a, b) => {
            const aDate = a.updatedAt ? new Date(a.updatedAt) : null;
            const bDate = b.updatedAt ? new Date(b.updatedAt) : null;

            if (aDate && bDate) return bDate - aDate;
            if (aDate) return -1;
            if (bDate) return 1;
            return 0;
        });
    }

    const handlePointerDown = (e) => {
        if (draggedElement.current) return;

        startX.current = e.clientX / oxDivider;
        startY.current = e.clientY / oyDivider;
        draggedElement.current = e.currentTarget;
        draggedElement.current.setPointerCapture(e.pointerId);
        draggedElement.current.pointerId = e.pointerId;

        draggedElement.current.style.transition = 'none';

        e.currentTarget.setPointerCapture(e.pointerId);
    };

    const handlePointerMove = (e) => {
        if (!draggedElement.current) return;
        if (e.pointerId !== draggedElement.current.pointerId) return;

        const deltaX = e.clientX / oxDivider - startX.current;
        const deltaY = e.clientY / oyDivider - startY.current;

        if (!isDragging.current && Math.abs(deltaX) > Math.abs(deltaY) && deltaX < 0) {
            isDragging.current = true;
            setDraggedNoteId(draggedElement.current.id)
        }

        if (isDragging.current) {
            e.preventDefault();
            if (deltaX > 0) {
                draggedElement.current.style.transform = `translateX(0px)`;
            } else if (deltaX < -130) {
                draggedElement.current.style.transform = `translateX(-130px)`;
            } else {
                draggedElement.current.style.transform = `translateX(${deltaX}px)`;
            }

        }
    };

    const handlePointerUp = (e, note) => {
        if (!draggedElement.current) return;
        if (e.pointerId !== draggedElement.current.pointerId) return;

        const deltaX = e.clientX / oxDivider - startX.current;

        draggedElement.current.releasePointerCapture(e.pointerId);

        if (isDragging.current) {
            if (deltaX < -100) {
                deleteNote(note._id);
            } else {
                draggedElement.current.style.transition = 'transform 0.2s ease-out';
                draggedElement.current.style.transform = 'translateX(0)';
                setTimeout(() => {
                    if (draggedElement.current) {
                        draggedElement.current.style.transition = '';
                    }
                }, 200);
            }
        }

        isDragging.current = false;
        draggedElement.current = null;
        setDraggedNoteId(null);
    };

    useEffect(() => {
        selectedNoteRef.current = selectedNote
    }, [selectedNote])

    const handleOnClickQrOrEmail = () => {
        setSelectedNote()
        if (currentParticipant?.role.toLowerCase() !== "visitor" && currentParticipant?.role.toLowerCase() !== "guest") {
            setShowQR(!showQR)
        } else {
            setShowSendToEmail(!showSendToEmail)
        }
    }

    return (
        <CustomMultitouchComponent ref={ref} dragGesture={false} x={1060} y={10} width={1578} height={980} options={options} onMinScaleReached={() => setSeeNoteFeature(false)}
            onPinch={onPinch} dragGestureMouse={true} dragBox={{ x: 0, y: 0, width: MAX_W, height: 84 }} isOpenCanvasRef={isOpenCanvasRef}>
            <div className={styles.component} ref={compRef} style={{ width: `${width}px`, height: `${height}px` }}>
                <div className={styles.leftPanel}>
                    <div className={styles.chatLabel}>
                        <FontAwesomeIcon className={styles.iconNotes} icon={byPrefixAndName.fal["notes"]} />
                        Notes
                    </div>
                    <div className={styles.notesList}>
                        {notesTexts && notesTexts.map((note, i) => (
                            <Fragment key={note._id}>
                                {(i === 0 || note.timeCategory !== notesTexts[i - 1].timeCategory) && <div>{note.timeCategory}</div>}
                                <div className={styles.noteCardTotal}>
                                    <div className={styles.removeSign} style={{ backgroundColor: draggedNoteId === note._id ? "#FF5D40" : "transparent" }}>
                                        <FontAwesomeIcon className={styles.iconTrash} icon={byPrefixAndName.fal["trash"]} />
                                    </div>
                                    <div className={styles.noteCard} id={note._id} style={{ backgroundColor: selectedNote?._id === note._id ? "#726FA8" : "" }}
                                        onPointerDown={(e) => handlePointerDown(e, note._id)}
                                        onPointerMove={handlePointerMove}
                                        onPointerUp={(e) => handlePointerUp(e, note)}
                                        onClick={() => {
                                            setSelectedNote(note)
                                            setShowQR(false)
                                            setShowSendToEmail(false)
                                            noteRef.current?.blur()
                                        }}>
                                        <div className={styles.noteText}>{getFirstLine(note.text)}</div>
                                        <div className={styles.noteCardDetails}>
                                            <div>Created: <b>{note.createdAt ? formatDate(note.createdAt) : "11/06/2025"}</b></div>
                                            <div>Edited: <b>{note.updatedAt ? formatDate(note.updatedAt) : "11/06/2025"}</b></div>
                                        </div>
                                    </div>

                                </div>

                            </Fragment>
                        ))}
                    </div>
                    <div className={styles.buttonsDiv}>
                        <div className={styles.newNoteButton} onClick={addNewNote}>
                            New Note
                        </div>
                        <div className={styles.qrButton} onClick={handleOnClickQrOrEmail}>
                            {currentParticipant?.role.toLowerCase() !== "visitor" && currentParticipant?.role.toLowerCase() !== "guest" &&
                                <FontAwesomeIcon icon={byPrefixAndName.fas['qrcode']} />}
                            {(currentParticipant?.role.toLowerCase() === "visitor" || currentParticipant?.role.toLowerCase() === "guest") &&
                                <FontAwesomeIcon icon={byPrefixAndName.fas["envelope-open-text"]} />}
                        </div>
                    </div>
                </div>
                <div className={styles.rightPanel}>
                    {selectedNote && !showQR && !showSendToEmail && <NoteAreaComponent ref={noteRef} keyboardRef={keyboardRef} value={selectedNote.text} onChange={changeNote}
                        placeHolder="New Note" width="100%" height="100%" />}
                    {!selectedNote && !showQR && !showSendToEmail && <div className={styles.backgroundImg} >
                        <img src={backgroundImg} alt={"backgroundImg"} />
                        Take a note
                    </div>}
                    {showQR && !showSendToEmail && <MobileQRComponent fromNote={true} />}
                    {!showQR && showSendToEmail && <div className={styles.backgroundImg} style={{ pointerEvents: "auto", userSelect: "auto" }}>
                        <img src={sendEmailImg} alt={"sendEmailImg"} />
                        Send your notes by email.
                        <div className={styles.emailInputLine}>
                            <New_InputTextComponent ref={inputEmailRef} keyboardRef={keyboardRef}
                                value={currentParticipant?.role.toLowerCase() === "guest" ? currentParticipant?.email : ""}
                                fontSize="32px" placeHolder="Email"
                                styleType='NOTESEMAIL' width="100%" height="90px" />
                            <div className={styles.buttonSendNotes} onClick={sendNotes} style={{ opacity: disabled ? 0.4 : 1 }}>
                                <FontAwesomeIcon icon={byPrefixAndName.fas["paper-plane-top"]} />
                            </div>
                        </div>
                    </div>}
                </div>

                <div className={styles.resizeButton} onPointerDown={resizePointerDown}>
                    <img src={resizeButton} alt={"resizeButton"} draggable={false} />
                </div>
                <FontAwesomeIcon className={styles.iconClose} onClick={() => setSeeNoteFeature(false)} icon={byPrefixAndName.fal['close']} />

            </div>



        </CustomMultitouchComponent>
    );
}

export default NotesComponent;
